import { ModelBase } from "@shoothill/core";
import { action, observable } from "mobx";

export class IncidentFormTypesLookupModel extends ModelBase<IncidentFormTypesLookupModel, any> {
    // #region Constructors and Disposers
    // #endregion Constructors and Disposers

    // #region Defaults and Constants

    public static readonly DEFAULT_ID = "";
    public static readonly DEFAULT_DISPLAYNAME = "";
    public static readonly DEFAULT_TYPE = 0;

    // #endregion Defaults and Constants

    // #region Observables

    @observable
    public id: string = IncidentFormTypesLookupModel.DEFAULT_ID;

    @observable
    public displayName: string = IncidentFormTypesLookupModel.DEFAULT_DISPLAYNAME;

    @observable
    public type: number = IncidentFormTypesLookupModel.DEFAULT_TYPE;

    // #endregion Observables

    // #region Actions

    @action
    public reset(): void {
        this.id = IncidentFormTypesLookupModel.DEFAULT_ID;
        this.displayName = IncidentFormTypesLookupModel.DEFAULT_DISPLAYNAME;
        this.type = IncidentFormTypesLookupModel.DEFAULT_TYPE;
    }

    @action
    public fromDto(dto: IncidentFormTypesDTO): void {
        this.id = dto.id;
        this.displayName = dto.displayName;
        this.type = dto.type;
    }

    public toDto() {
        throw new Error("Method not implemented.");
    }

    // #endregion Actions

    // #region Helpers

    public static fromDtos(dtos: IncidentFormTypesDTO[]): IncidentFormTypesLookupModel[] {
        const types: IncidentFormTypesLookupModel[] = [];

        for (const dto of dtos) {
            const model = new IncidentFormTypesLookupModel();

            model.fromDto(dto);
            types.push(model);
        }

        return types;
    }

    // #endregion Helpers
}

export interface IncidentFormTypesDTO {
    id: string;
    displayName: string;
    type: number;
}

export enum IncidentFormTypesEnum {
    NearMiss = 10,
    Accident = 20,
    WitnessStatement = 30,
}
